const trimExtraSymbols = (str: string): string => {
    return str.trim().replace(/(^[-']*|[-']*$)/g, '');
};

export default trimExtraSymbols;
